<template>
  <i
    class="tm-visual-sprite"
    :class="{
      d: $props.showDim,
      se: $props.isSceneEdit,
    }"
  >
    <i
      v-for="(spriteRectangle, i) in sprite"
      :key="i"
      :style="spriteRectangle.styleObj"
    />
  </i>
</template>

<script>
import { generateSpriteRectangles } from '../../../api/asset';
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'tm-visual-sprite',

  props: {
    track: { type: Object, required: true },
    rectangle: { type: Object, required: true },
    showDim: { type: Boolean, required: true },
    isSelected: { type: Boolean, required: true },
    isSceneEdit: { type: Boolean, required: true },
  },

  computed: {
    ...mapGetters('timemachine', ['grid']),
    ...mapState('timemachine', {
      pxAssetHeight: (state) => state.cssVariables.pxAssetHeight,
      pxAssetWidth: (state) => state.cssVariables.pxAssetWidth,
    }),

    sprite() {
      const selected = this.$props.isSelected;
      const empty = this.$props.track.pipa.isEmpty();
      const editing = this.$props.isSceneEdit;
      const useRTP = !editing && (!selected || (selected && empty));

      return generateSpriteRectangles(
        this.grid,
        this.$props.track.data,
        this.$props.rectangle,
        this.pxAssetWidth,
        this.pxAssetHeight,
        useRTP,
        this.$props.track.colourCardCss
      );
    },
  },
};
</script>

<style lang="scss">
.tm-visual-span .tm-visual-sprite {
  position: absolute;
  top: 0;
  z-index: var(--tm-zVisualSprite);
  pointer-events: none;
  white-space: nowrap;
  overflow: hidden;

  &.d:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
  }

  > i {
    display: inline-block;
    background-repeat: no-repeat;
    background-size: cover;
  }
}
</style>
